import { colors } from '../sharedStyles';

export default function Hero({ scrollToSection }) {
    return (
        <section id="hero" style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: 'clamp(8rem, 20vh, 16rem)', paddingBottom: '4rem', paddingLeft: '1.5rem', paddingRight: '1.5rem', backgroundColor: colors.darkBg, backgroundImage: `linear-gradient(135deg, ${colors.darkBg} 0%, rgba(20, 45, 85, 0.95) 100%)` }}>
            <div style={{ maxWidth: '64rem', margin: '0 auto', textAlign: 'center' }}>

                <h1 className="fade-in-up" style={{ fontSize: 'clamp(2.5rem, 8vw, 5rem)', fontWeight: 700, marginBottom: '2rem', lineHeight: 1.1, color: colors.white }}>
                    Directeur financier (DAF)<br></br> à temps partagé <br></br> pour PME en croissance
                </h1>

                <p className="fade-in-up" style={{ fontSize: '1.25rem', marginBottom: '3rem', fontWeight: 300, maxWidth: '48rem', margin: '0 auto 3rem', color: 'rgba(255, 255, 255, 0.9)', lineHeight: 1.6 }}>
                    Structurez votre pilotage financer, sécurisez votre gestion de trésorerie et transformez votre fonction finance en levier stratégique de décision.
                </p>

                <div className="fade-in-up" style={{ display: 'flex', flexWrap: 'wrap', gap: '1.5rem', justifyContent: 'center', alignItems: 'center' }}>
                    <button
                        onClick={() => scrollToSection('contact')}
                        style={{
                            backgroundColor: colors.white,
                            color: colors.darkBg,
                            padding: '1rem 2rem',
                            borderRadius: '50px',
                            fontWeight: 700,
                            fontSize: '1rem',
                            border: 'none',
                            cursor: 'pointer',
                            boxShadow: '0 4px 15px rgba(255, 255, 255, 0.2)',
                            transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => { e.target.style.transform = 'translateY(-3px)'; e.target.style.boxShadow = '0 8px 25px rgba(255, 255, 255, 0.3)'; }}
                        onMouseLeave={(e) => { e.target.style.transform = 'translateY(0)'; e.target.style.boxShadow = '0 4px 15px rgba(255, 255, 255, 0.2)'; }}
                    >
                        Prendre rendez-vous
                    </button>

                    <button
                        onClick={() => scrollToSection('services')}
                        style={{
                            backgroundColor: 'transparent',
                            color: colors.white,
                            padding: '1rem 2rem',
                            borderRadius: '50px',
                            fontWeight: 600,
                            fontSize: '1rem',
                            border: `2px solid rgba(255, 255, 255, 0.3)`,
                            cursor: 'pointer',
                            transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => { e.target.style.borderColor = colors.white; e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)'; }}
                        onMouseLeave={(e) => { e.target.style.borderColor = 'rgba(255, 255, 255, 0.3)'; e.target.style.backgroundColor = 'transparent'; }}
                    >
                        Découvrir la méthode
                    </button>
                </div>

            </div>
        </section>
    );
}
